import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Upload, X, FileText, Maximize2, Minimize2 } from 'lucide-react';
import './style/UploadExamPdf.css';

export default function UploadExamPdf() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      alert('Please select a PDF file.');
    }
  };

  const handleUpload = () => {
    if (selectedFile) {
      console.log('Uploading exam file:', selectedFile.name);
      // Redirect to ExamProcessing component
      navigate('/exams/process');
    } else {
      alert('Please select a file to upload.');
    }
  };

  const closePreview = () => {
    setPreviewUrl(null);
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  return (
    <div className="unique15-exam-pdf-upload-container bg-gradient-to-br from-blue-100 to-purple-100">
      <div className="unique15-exam-pdf-upload-card">
        <h2 className="unique15-exam-pdf-upload-title">Upload Exam PDF</h2>
        <div className="unique15-exam-pdf-file-input-wrapper">
          <input
            type="file"
            accept=".pdf"
            onChange={handleFileChange}
            ref={fileInputRef}
            id="unique15-exam-pdf-file-input"
            className="unique15-exam-pdf-file-input"
          />
          <label htmlFor="unique15-exam-pdf-file-input" className="unique15-exam-pdf-file-input-label">
            <Upload size={24} />
            <span>{selectedFile ? selectedFile.name : 'Choose Exam PDF file'}</span>
          </label>
        </div>
        <button className="unique15-exam-pdf-upload-button" onClick={handleUpload} disabled={!selectedFile}>
          Process Exam PDF
        </button>
        {previewUrl && (
          <div className={`unique15-exam-pdf-preview-container ${isFullscreen ? 'unique15-fullscreen' : ''}`}>
            <div className="unique15-exam-pdf-preview-header">
              <div className="unique15-exam-pdf-preview-title">
                <FileText size={24} />
                <span>Exam PDF Preview</span>
              </div>
              <div className="unique15-exam-pdf-preview-actions">
                <button className="unique15-exam-pdf-fullscreen-toggle" onClick={toggleFullscreen}>
                  {isFullscreen ? <Minimize2 size={24} /> : <Maximize2 size={24} />}
                </button>
                <button className="unique15-exam-pdf-close-preview" onClick={closePreview}>
                  <X size={24} />
                </button>
              </div>
            </div>
            <div className="unique15-exam-pdf-preview-wrapper">
              <iframe src={previewUrl} title="Exam PDF Preview" className="unique15-exam-pdf-preview-iframe" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}